var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvasBox",style:(("\n    height: " + _vm.canvasBoxHeight + ";\n    width: " + _vm.canvasBoxWidth + ";"))},[_c('canvas',{attrs:{"id":"canvas"}})])}
var staticRenderFns = []

export { render, staticRenderFns }